import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMagLandings } from "./UseMagLandings";
import MagLandingsFrame from "./MagLandingsFrame";
import GroupsGrid from "./Group/GroupsGrid";

export default function Product4(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { LandingInfo } = UseMagLandings();
  const [landingInfo, setLandingInfo] = useState();

  useEffect(() => {
    setProgress(true);
    LandingInfo(location.state.LandingID, (callback) => {
      setLandingInfo(callback);
    });
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/magmanagment",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/magmanagment" },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/magmanagment/LandingsManage",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            فریم نمایش
          </Typography>
          <MagLandingsFrame
            hid={location.state.LandingID}
            landingInfo={landingInfo && landingInfo}
            setLandingInfo={setLandingInfo}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            گروه ها
          </Typography>
          <GroupsGrid
            thisOfferId={
              landingInfo && landingInfo.id ? landingInfo.id : undefined
            }
            LandingID={landingInfo && landingInfo.id}
            rows={landingInfo && landingInfo.groups ? landingInfo.groups : []}
            landingInfo={landingInfo && landingInfo}
            setLandingInfo={setLandingInfo}
            componentAID={location.state.LandingID}
            callback={() => {
              LandingInfo(location.state.LandingID, (callback) => {
                setLandingInfo(callback);
              });
            }}
          />
        </Box>
      </Box>
    </Detail>
  );
}
